﻿import React, { useState } from 'react';
import { AuditingTable } from "components/auditing";
import { FleetService } from "services";
import { useParams } from "react-router-dom";

export function EventTypeChangelog(props) {

    const { id } = useParams();

    const noDataMessage = "It looks like no previous changes have been made to your event type settings.";
    const [tableData, setTableData] = useState(null);
    const [tableRecordCount, setTableRecordCount] = useState(0);

    function onTableChange(pageSize, pageNumber, startDate, endDate) {
        FleetService.getEventTypeChangelog(id, pageSize, pageNumber, startDate, endDate).then(r => {
            setTableData(r.data);
            setTableRecordCount(r.totalCount);
        });
    }

    return (
        <AuditingTable data={tableData} totalCount={tableRecordCount} onChange={onTableChange} noDataMessage={noDataMessage}></AuditingTable>
    );
}